(() => {
  const init = (root = document) => {
    const sections = root.querySelectorAll(".testimonial-video[data-testimonial-video]");
    if (!sections.length) return;

    if (!("IntersectionObserver" in window)) {
      sections.forEach((s) => s.classList.add("is-visible"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.25, rootMargin: "0px 0px -10% 0px" }
    );

    sections.forEach((s) => {
      if (s.classList.contains("is-visible")) return;
      io.observe(s);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());

  document.addEventListener("shopify:section:load", (e) => {
    init(e.target);
  });
})();